import { gql } from '@apollo/client';

export const GET_PAGE_BY_SLUG = gql`
  query GetPageBySlug(
    $slug: String!
    $locale: String!
    $tagId: String!
    $preview: Boolean!
  ) {
    meetingPlacePageTenantShopListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        sys {
          id
          locale
        }
        __typename
      }
    }

    # Food beverage
    meetingPlacePageTenantFoodbeverageListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        sys {
          id
          locale
        }
        __typename
      }
    }

    # Entertainment
    meetingPlacePageTenantEntertainmentListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        sys {
          id
          locale
        }
        __typename
      }
    }

    # Tenant List
    meetingPlacePageTenantListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        sys {
          id
          locale
        }
        __typename
      }
    }

    # Service
    meetingPlacePageServiceListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        sys {
          id
          locale
        }
        __typename
      }
    }

    # offer list
    meetingPlacePageOfferListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        sys {
          id
        }
        __typename
      }
    }

    # Find Us
    meetingPlacePageFindUsCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # Legal Document
    meetingPlacePageLegalDocumentCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # editorial
    meetingPlacePageEditorialCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
        openingHours
      }
    }

    #Editorial Full width
    meetingPlacePageEditorialFullWidthCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # Editorial List

    meetingPlacePageEditorialListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # News list
    meetingPlacePageNewsListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # News list
    meetingPlacePageEventListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # News list
    meetingPlacePageLeisurePackageOfferListCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # Occasion list
    meetingPlacePageOccasionsCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # Floor plan
    meetingPlacePageFloorPlanCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # Search Results
    meetingPlacePageSearchResultsCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }

    # IFrame Collection
    meetingPlacePageIframeCollection(
      where: {
        slug: $slug
        contentfulMetadata: { tags: { id_contains_some: [$tagId] } }
      }
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        __typename
        sys {
          id
        }
      }
    }
  }
`;
